let sessionEnding = false
const persistenceCancelHandlers = new Set<() => void>()
const backupFlushHandlers = new Set<() => void>()
const sessionEndDiscardHandlers = new Set<() => void>()

export function isSessionEnding(): boolean {
  return sessionEnding
}

export function endSessionEnd() {
  sessionEnding = false
}

export function onCancelPendingPersistence(handler: () => void): () => void {
  persistenceCancelHandlers.add(handler)
  return () => {
    persistenceCancelHandlers.delete(handler)
  }
}

export function onFlushPendingBackup(handler: () => void): () => void {
  backupFlushHandlers.add(handler)
  return () => {
    backupFlushHandlers.delete(handler)
  }
}

export function onSessionEndDiscard(handler: () => void): () => void {
  sessionEndDiscardHandlers.add(handler)
  return () => {
    sessionEndDiscardHandlers.delete(handler)
  }
}

export function cancelPendingPersistence() {
  persistenceCancelHandlers.forEach((handler) => {
    handler()
  })
}

export function beginSessionEnd(options: { flushBackups?: boolean } = {}) {
  if (sessionEnding) {
    return
  }

  if (options.flushBackups) {
    backupFlushHandlers.forEach((handler) => {
      handler()
    })
  }

  cancelPendingPersistence()
  sessionEnding = true
  sessionEndDiscardHandlers.forEach((handler) => {
    handler()
  })
}
